import script from "./SearchHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchHistory.vue?vue&type=script&setup=true&lang=js"

import "./SearchHistory.vue?vue&type=style&index=0&id=6b00fefd&lang=css"

const __exports__ = script;

export default __exports__